import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

export function TopBar() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-20 border-b border-tile-edge bg-[#fffdf6]/95 backdrop-blur">
      <div className="mx-auto flex h-14 w-full max-w-content items-center justify-between px-4">
        <Link
          to="/"
          aria-label="Scrabble Daily"
          className="flex items-center gap-2 text-lg font-bold tracking-tight text-stone-900"
        >
          {/* Same tile mark as the favicon, kept in sync from the one source. */}
          <img src="/favicon.svg" alt="" aria-hidden="true" className="h-7 w-7" />
          {/* Brand text yields to the nav on narrow phones. */}
          <span className="hidden sm:inline">Scrabble&nbsp;Daily</span>
        </Link>
        <nav className="flex items-center gap-2 text-sm sm:gap-3" aria-label="Account">
          <Link to="/leaderboard" className="text-stone-600 hover:text-stone-900">
            Leaderboard
          </Link>
          <Link to="/history" className="text-stone-600 hover:text-stone-900">
            History
          </Link>
          {loading ? null : user ? (
            <>
              <Link
                to="/settings"
                className="max-w-24 truncate font-medium text-stone-800 hover:text-stone-950"
              >
                {user.display_name}
              </Link>
              <button
                type="button"
                onClick={async () => {
                  await logout();
                  navigate('/');
                }}
                className="text-stone-600 hover:text-stone-900"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="rounded-md bg-emerald-700 px-3 py-1.5 font-medium text-white hover:bg-emerald-800"
            >
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
